import React, { useEffect, useState } from "react";
import Input from "../../../../components/FormElement/Search";
import { useFormik } from "formik";
import { FormWrapper } from "../style";
import Button from "../../../../components/FormElement/Button";
import { useHideModal } from "../../../../hooks";
import * as Yup from "yup";
import LangTab from "../../../../components/FormElement/LangTab";
import Spinner from "../../../../components/Spinner/FullScreen";
import { useShowAlert } from "../../../../hooks/useAlerts";
import service from "../../../../services/statistics";

function Form({ edit, fetch, active }) {
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const [language, setLanguage] = useState("UZL");
  const { hideModal } = useHideModal();

  const validationSchema = Yup.object({
    title: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    desc: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    count: Yup.string().required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      title: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      desc: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      count: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
      };
      setLoading(true);
      if (edit) {
        service
          .update(edit, payload)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(payload)
          .then(() => {
            hideModal();
            fetch();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (edit) {
      setLoading(true);
      service
        .getOne(edit)
        .then((resp) => {
          formik.setValues({
            title: {
              UZL: resp?.title?.UZL,
              UZK: resp?.title?.UZK,
              RUS: resp?.title?.RUS,
              ENG: resp?.title?.ENG,
            },
            desc: {
              UZL: resp?.desc?.UZL,
              UZK: resp?.desc?.UZK,
              RUS: resp?.desc?.RUS,
              ENG: resp?.desc?.ENG,
            },
            count: resp?.count,
          });
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  const onLangChange = (key) => {
    setLanguage(key);
  };

  if (loading) return <Spinner />;
  return (
    <FormWrapper>
      <form onSubmit={formik.handleSubmit}>
        {active ? (
          <>
            <Input
              id="count"
              name="count"
              label="Loyihalar soni"
              type="number"
              width={100}
              placeholder="Soni"
              onChange={formik.handleChange}
              value={formik.values?.count}
              status={
                formik?.errors?.count && formik.touched.count ? "error" : ""
              }
            />
          </>
        ) : (
          <>
            <LangTab defaultActiveKey="1" onChange={onLangChange} />
            <Input
              id="title"
              name="title"
              label="Bo'lim"
              width={100}
              placeholder="Bo'lim nomi"
              onChange={(e) => {
                formik.setFieldValue(`title.${language}`, e.target.value);
              }}
              value={formik.values?.title[language]}
              status={
                formik?.errors?.title && formik.touched.title ? "error" : ""
              }
            />
            <Input
              id="desc"
              name="desc"
              label="Izoh"
              width={100}
              placeholder="Izoh"
              onChange={(e) => {
                formik.setFieldValue(`desc.${language}`, e.target.value);
              }}
              value={formik.values?.desc[language]}
              status={
                formik?.errors?.desc && formik.touched.desc ? "error" : ""
              }
            />
            <Input
              id="count"
              name="count"
              label="Loyihalar soni"
              type="number"
              width={100}
              placeholder="Soni"
              onChange={formik.handleChange}
              value={formik.values?.count}
              status={
                formik?.errors?.count && formik.touched.count ? "error" : ""
              }
            />
          </>
        )}

        <Button
          htmlType="submit"
          className="sendBtn"
          text={edit || active ? "Yangilash" : "Qo'shish"}
          width="100%"
        />
      </form>
    </FormWrapper>
  );
}

export default Form;
